import script from "./WCDigitalCouponCardModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCDigitalCouponCardModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCDigitalCouponCardModern.vue?vue&type=style&index=0&id=41230802&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41230802"]])

export default __exports__